import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api/apiServises';
import {
  ADD_WHEEL_STAGE_ONE,
  GET_WHEEL_STAGE_ONE_LIST,
  DELETE_WHEEL_STAGE_ONE,
  VIEW_WHEEL_STAGE_ONE,
  REJECT_STAGE_ONE,
  ADD_WHEEL_STAGE_FOUR,
  GET_WHEEL_STAGE_FOUR_LIST,
  UPDATE_WHEEL_FLOW,
  WHEEL_FLOW_HISTORY,
  GET_WHEEL_STAGE_FOUR_REJECT_FORWARD,
  ADD_WHEEL_STAGE_TWO,
  ADD_WHEEL_STAGE_THREE,
  GET_WHEEL_STAGE_THREE_LIST,
  UPDATE_WHEEL_STAGE_THREE,
  VIEW_WHEEL_STAGE_THREE,
  ADD_WHEEL_STAGE_SIX,
  GET_WHEEL_STAGE_SIX_LIST,
  UPDATE_WHEEL_STAGE_SIX,
  VIEW_WHEEL_STAGE_SIX,
  ADD_WHEEL_STAGE_TWO_BRAKE_DISC,
  GET_WHEEL_STAGE_TWO_BRAKE_DISC_LIST,
  VIEW_WHEEL_STAGE_TWO_BRAKE_DISC,
  REJECT_WHEEL_STAGE_TWO_BRAKE_DISC,
  REJECT_STAGE_THREE,
  REJECT_STAGE_SIX,
  REJECT_STAGE_FOUR,
  DELETE_WHEEL_STAGE_DATA,
  STORE_WHEEL_DAILY_REPORT,
  FETCH_WHEEL_DAILY_REPORT,
  WHEEL_SHOP_QC_REPORT,
} from '../../../api/apiConstant';

export const addWheelStageOneData = createAsyncThunk(
  'wheel/addWheelStageOneData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_WHEEL_STAGE_ONE, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to save wheel stage one data',
      );
    }
  },
);

export const fetchWheelStageOneList = createAsyncThunk(
  'wheel/fetchWheelStageOneList',
  async (params, thunkAPI) => {
    try {
      const response = await api.get(GET_WHEEL_STAGE_ONE_LIST, {
        params
        // params: {
        //   page: params.page,
        //   perPage: params.perPage,
        //   date: params.date,
        //   axle_no: params.axle_no,
        //   rbl_no: params.rbl_no,
        // },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

// Add rejection thunk
export const rejectWheelStageOne = createAsyncThunk(
  'wheel/rejectStageOne',
  async (formData, { rejectWithValue }) => {
    try {
      // const response = await axios.post('/api/wheel/stage-one/reject', formData, {
      //   headers: { 'Content-Type': 'multipart/form-data' },
      // });
      const response = api.post(REJECT_STAGE_ONE, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getWheelFlowHistory = createAsyncThunk(
  'roof/fetchRoofFlowHistory',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(WHEEL_FLOW_HISTORY, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch flow history',
      );
    }
  },
);

export const updateWheelFlowStatus = createAsyncThunk(
  'wheel/updateFlowStatus',
  async ({ stageId, flowStatus, remark, stageType,freezeDate }, { rejectWithValue }) => {
    try {
      const response = api.post(UPDATE_WHEEL_FLOW, {
        stage_id: stageId,
        stage_type: stageType,
        flow_status: flowStatus,
        remark,
        freeze_date: freezeDate,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const deleteWheelStageOneData = createAsyncThunk(
  'wheel/deleteWheelStageOneData',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_WHEEL_STAGE_ONE}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to delete wheel stage one data',
      );
    }
  },
);

export const fetchViewWheelStageOne = createAsyncThunk(
  'wheel/fetchViewWheelStageOne',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${VIEW_WHEEL_STAGE_ONE}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch wheel stage one details',
      );
    }
  },
);

export const addWheelStageFourData = createAsyncThunk(
  'wheel/addWheelStageFourData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_WHEEL_STAGE_FOUR, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to save wheel stage one data',
      );
    }
  },
);
export const fetchWheelStageFourList = createAsyncThunk(
  'wheel/fetchWheelStageFourList',
  async (
    {
      page = 1,
      perPage = 10,
      search = '',
      confirming = '',
      flow_status: flowStatus = '',
      rbl_no: rblNo = ''
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await api.get(GET_WHEEL_STAGE_FOUR_LIST, {
        params: {
          page,
          per_page: perPage,
          search,
          confirming,
          flow_status: flowStatus,
          rbl_no: rblNo
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch wheel stage four list',
      );
    }
  },
);

export const addWheelStageThreeData = createAsyncThunk(
  'wheel/addWheelStageThreeData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_WHEEL_STAGE_THREE, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to save wheel stage three data',
      );
    }
  },
);

export const fetchWheelStageThreeList = createAsyncThunk(
  'wheel/fetchWheelStageThreeList',
  async (params, thunkAPI) => {
    try {
      const response = await api.get(GET_WHEEL_STAGE_THREE_LIST, {
        params: {
          page: params.page,
          perPage: params.perPage,
          date: params.date,
          wheel_no: params.wheel_no,
          rbl_no: params.rbl_no,
          search: params.search,
          confirming: params.confirming,
          flow_status: params.flow_status,
        },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  },
);

export const updateWheelStageThreeData = createAsyncThunk(
  'wheel/updateWheelStageThreeData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_WHEEL_STAGE_THREE, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to save wheel stage six data',
      );
    }
  },
);

export const fetchViewWheelStageThree = createAsyncThunk(
  'wheel/fetchViewWheelStageThree',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${VIEW_WHEEL_STAGE_THREE}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch wheel stage one details',
      );
    }
  },
);

export const addWheelStageSixData = createAsyncThunk(
  'wheel/addWheelStageSixData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_WHEEL_STAGE_SIX, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to save wheel stage six data',
      );
    }
  },
);

export const fetchWheelStageSixList = createAsyncThunk(
  'wheel/fetchWheelStageSixList',
  async (params, thunkAPI) => {
    try {
      const response = await api.get(GET_WHEEL_STAGE_SIX_LIST, {
        params: {
          page: params.page,
          per_page: params.perPage,
          date: params.date,
          rbl_no: params.rbl_no,
          search: params.search,
          confirming: params.confirming,
          flow_status: params.flow_status,
        },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  },
);

export const updateWheelStageSixData = createAsyncThunk(
  'wheel/updateWheelStageSixData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_WHEEL_STAGE_SIX, formData);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fetchViewWheelStageSix = createAsyncThunk(
  'wheel/fetchViewWheelStageSix',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${VIEW_WHEEL_STAGE_SIX}/${id}`);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const upadteStatusWheelStageFourData = createAsyncThunk(
  'wheel/upadteStatusWheelStageFourData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_WHEEL_STAGE_FOUR_REJECT_FORWARD, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to save wheel stage one data',
      );
    }
  },
);
//stage two
export const addWheelStageTwoData = createAsyncThunk(
  'wheel/addWheelStageTwoData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_WHEEL_STAGE_TWO, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to save wheel stage TWO data',
      );
    }
  },
);
export const fetchWheelStageTwoList = createAsyncThunk(
  'wheel/fetchWheelStageTwoList',
  async (params) => {
    const response = await api.get('/api/wheel-stage-two-list', { params });
    return response.data;
  },
);
export const rejectWheelStageTwo = createAsyncThunk(
  'wheel/rejectWheelStageTwo',
  async (formData) => {
    const response = await api.post('/api/wheel-stage-two-reject', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
);
export const viewWheelStageTwoData = createAsyncThunk('wheel/viewWheelStageTwoData', async (id) => {
  const response = await api.get(`/api/wheel-stage-two-view/${id}`);
  return response.data;
});
//wheel stage two brakedisc
export const addWheelStageTwoBrakeDiscData = createAsyncThunk(
  'wheel/addWheelStageTwoBrakeDiscData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_WHEEL_STAGE_TWO_BRAKE_DISC, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to save wheel stage two brake disc data',
      );
    }
  },
);

// Fetch Stage Two Brake Disc List
export const fetchWheelStageTwoBrakeDiscList = createAsyncThunk(
  'wheel/fetchWheelStageTwoBrakeDiscList',
  async (params) => {
    const response = await api.get(GET_WHEEL_STAGE_TWO_BRAKE_DISC_LIST, { params });
    return response.data;
  },
);

// View Stage Two Brake Disc
export const viewWheelStageTwoBrakeDiscData = createAsyncThunk(
  'wheel/viewWheelStageTwoBrakeDiscData',
  async (id) => {
    const response = await api.get(`${VIEW_WHEEL_STAGE_TWO_BRAKE_DISC}/${id}`);
    return response.data;
  },
);

// Reject Stage Two Brake Disc
export const rejectWheelStageTwoBrakeDisc = createAsyncThunk(
  'wheel/rejectWheelStageTwoBrakeDisc',
  async (formData) => {
    const response = await api.post(REJECT_WHEEL_STAGE_TWO_BRAKE_DISC, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
);

export const rejectWheelStageThree = createAsyncThunk(
  'wheel/rejectWheelStageThree',
  async (formData, { rejectWithValue }) => {
    try {
      // const response = await axios.post('/api/wheel/stage-one/reject', formData, {
      //   headers: { 'Content-Type': 'multipart/form-data' },
      // });
      const response = api.post(REJECT_STAGE_THREE, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const rejectWheelStageSix = createAsyncThunk(
  'wheel/rejectWheelStageSix',
  async (formData, { rejectWithValue }) => {
    try {
      // const response = await axios.post('/api/wheel/stage-one/reject', formData, {
      //   headers: { 'Content-Type': 'multipart/form-data' },
      // });
      const response = api.post(REJECT_STAGE_SIX, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const rejectWheelStageFour = createAsyncThunk(
  'wheel/rejectWheelStageFour',
  async (formData, { rejectWithValue }) => {
    try {
      // const response = await axios.post('/api/wheel/stage-one/reject', formData, {
      //   headers: { 'Content-Type': 'multipart/form-data' },
      // });
      const response = api.post(REJECT_STAGE_FOUR, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const deleteWheelStageData = createAsyncThunk(
  'furnishing/deleteWheelStageData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(DELETE_WHEEL_STAGE_DATA, formData);
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Delete Failed');
    }
  },
);
export const storeWheelReportData = createAsyncThunk(
  'wheel/storeWheelReportData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_WHEEL_DAILY_REPORT, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to save wheel report',
      );
    }
  },
);
export const fetchWheelReportData = createAsyncThunk(
  'wheel/fetchWheelReportData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_WHEEL_DAILY_REPORT, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch wheel report',
      );
    }
  },
);

export const wheelShopQcReport = createAsyncThunk(
  'wheel/wheelShopQcReport',
  async (params) => {
    const response = await api.get(WHEEL_SHOP_QC_REPORT, { params });
    return response.data;
  },
);
